var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1038 14.7473C16.0838 14.7473 16.0704 14.7473 16.0504 14.7473C16.0171 14.7407 15.9704 14.7407 15.9304 14.7473C13.9971 14.6873 12.5371 13.1673 12.5371 11.294C12.5371 9.38732 14.0904 7.83398 15.9971 7.83398C17.9038 7.83398 19.4571 9.38732 19.4571 11.294C19.4504 13.1673 17.9838 14.6873 16.1238 14.7473C16.1171 14.7473 16.1104 14.7473 16.1038 14.7473ZM15.9971 8.83398C14.6438 8.83398 13.5371 9.94065 13.5371 11.294C13.5371 12.6273 14.5771 13.7007 15.9038 13.7473C15.9371 13.7407 16.0304 13.7407 16.1171 13.7473C17.4238 13.6873 18.4504 12.614 18.4571 11.294C18.4571 9.94065 17.3504 8.83398 15.9971 8.83398Z",
    fill: "#333853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 22.0327C14.8045 22.0327 13.4911 21.6993 12.4978 21.0327C11.5711 20.4193 11.0645 19.5793 11.0645 18.666C11.0645 17.7527 11.5711 16.906 12.4978 16.286C14.4978 14.9593 17.7378 14.9593 19.7245 16.286C20.6445 16.8993 21.1578 17.7393 21.1578 18.6527C21.1578 19.566 20.6511 20.4127 19.7245 21.0327C18.7245 21.6993 17.4178 22.0327 16.1111 22.0327ZM13.0511 17.126C12.4111 17.5527 12.0645 18.0993 12.0645 18.6727C12.0645 19.2393 12.4178 19.786 13.0511 20.206C14.7111 21.3193 17.5111 21.3193 19.1711 20.206C19.8111 19.7793 20.1578 19.2327 20.1578 18.6593C20.1578 18.0927 19.8045 17.546 19.1711 17.126C17.5111 16.0193 14.7111 16.0193 13.0511 17.126Z",
    fill: "#333853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherUsers);
export default __webpack_public_path__ + "static/media/other_users.87d380b5aaca3ec0dc296a31a9ada4f3.svg";
export { ForwardRef as ReactComponent };